import {View} from 'react-native';
import * as React from 'react';
import {useTheme} from '../../theme';
import {Props} from './model';

export const Hr = (props: Props) => {
  const theme = useTheme();
  return (
    <View
      style={{
        marginTop: props.marginTop ?? 40,
        marginBottom: props.marginBottom ?? 40,
        ...theme.hr,
        borderBottomColor: props.color ?? theme.hr.borderBottomColor,
      }}
    />
  );
};
